import React, { Component } from 'react';
import axios from '../../axios';
import format from 'format-number'
import { connect } from 'react-redux'
import moment from 'moment'
import { resetCekKartuState } from '../../actions/formCekKartuAction'
import Alert from 'react-s-alert'

const initialState = {    
    no_rm               : "",
    tgl_transaksi       : moment().format('YYYY-MM-DD'),
    dateTransaksi       : moment(),
    namaPasien          : "",
    totalTransaksi      : 0,
    noKartu             : "",    
    dataPeriksa         : [
        {
            item_periksa: "",
            harga: 0
        }
    ],
    isButtonLoading     : false,
    isLoading           : false,
}

class DetailTransaksi extends Component {
    constructor(props) {
        super(props)

        this.state = initialState
    }            

    loadDetailData() {

        axios.get("/rumah_sakit/getDetailDataTransaksi/" + this.props.match.params.id_histori_transaksi + "?id_kartu_anggota=" + this.props.id_kartu_anggota + "&getOneRow=1")
            .then(response => {

                const result = response.data                 
                
                this.setState({ 
                    no_rm           : result[0].no_rm,
                    namaPasien      : result[0].nama_anggota,
                    noKartu         : result[0].kartu_kode,
                    totalTransaksi  : result[0].total_periksa,
                    dataPeriksa     : result
                })
            })
            .catch(error => {
                
                console.log(error)
                Alert.error("Gagal terhubung ke server!")
            })
    }
    
    componentDidMount() {
        this.loadDetailData()
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.id_kartu_anggota !== this.props.id_kartu_anggota) {

            this.loadDetailData()
        }
    }
    
    render() {

        return (
            <div className="col-sm-12">                
                <div className="card">
                    <div className="card-header">
                        Informasi Transaksi
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Nomor Kartu</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.noKartu}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Nomor Rekam Medis</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.no_rm}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Nama Pasien</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.namaPasien}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Tanggal Transaksi</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.tgl_transaksi}</b>
                            </div>
                        </div> 
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Total Transaksi</label>
                            <div className="col-md-10">
                                {": "}<b>{format({prefix: 'Rp ', integerSeparator: "."})(this.state.totalTransaksi)}</b>
                            </div>
                        </div>                                              
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        Data Item Transaksi
                    </div>
                    <div className="card-block">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="25">No</th>
                                    <th>Nama Item</th>
                                    <th>Harga</th>
                                </tr>
                            </thead>
                            <tbody>                                                                
                            {
                                this.state.dataPeriksa.map((item, i) => (
                                    <tr key={"dataPeriksa" + i}>
                                        <td>
                                            {i + 1}
                                        </td>
                                        <td>
                                            {this.state.dataPeriksa[i].item_periksa}
                                        </td>
                                        <td>                                            
                                            {format({prefix: 'Rp ', integerSeparator: "."})(this.state.dataPeriksa[i].harga_item)}
                                        </td>
                                    </tr>
                                ))
                            }       
                            </tbody>
                        </table>   
                    </div>
                </div>                    
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    city_id             : state.authReducer.city_id,
    cekKartuState       : state.formCekKartu,
    isKartuValid        : state.formCekKartu.isKartuValid,
    id_kartu_anggota    : state.formCekKartu.id_kartu_anggota,
    sudahTerdaftar      : state.formCekKartu.sudahTerdaftar,
    id_kartu_saldo      : state.formCekKartu.id_kartu_saldo,
})

const mapDispatchToProps = (dispatch) => ({
    resetCekKartuState: () => {
        dispatch(resetCekKartuState())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailTransaksi);


// WEBPACK FOOTER //
// ./src/views/Transaksi/DetailTransaksi.js